import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CompanyEurekaApi, GetSampleCompanyRequest, GetSampleCompanyResponse } from '../company-eureka-api';

@injectable()
export class CompanyEurekaApiImpl extends PsHttpService implements CompanyEurekaApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getSampleCompany(params: GetSampleCompanyRequest) {
        return this.get<PatSnapCommonResponseData<GetSampleCompanyResponse>>({
            url: '/insights/company/example',
            params,
        }).then((res) => {
            return res.data as GetSampleCompanyResponse;
        });
    }
}
